<template>
  <div class="order-item global_pointer" @click="jumpDetail(itemDetail.id)">
    <div class="order-item-top">
      <div class="left" id="left">
        <p>{{ orderLan.orderNo }} {{ itemDetail.orderNo }}</p>
        <button @click.stop="copyOrderNo(itemDetail.orderNo)">
          {{ orderLan.copy }}
        </button>
      </div>
      <div class="right">
        {{ itemDetail.orderStateDesc }}
      </div>
    </div>
     <div class="business" v-if="itemDetail&&itemDetail.orderMerchandises">
      <img v-if="itemDetail.orderMerchandises[0].business.headImg" :src="itemDetail.orderMerchandises[0].business.headImg.url" alt="" /> 
      <span>{{ itemDetail.orderMerchandises[0].business.name }}</span>
    </div> 
    <GoodsInfo
      v-for="itemGoods in itemDetail.orderMerchandises"
      :key="itemGoods.id"
      :itemGoods="itemGoods"
    >
    </GoodsInfo>
    <div class="order-info">
      <span
        >{{ orderLan.all }} {{ itemDetail.buyNum }}{{ orderLan.numShop }}</span
      >
      <span class="total-text">{{ orderLan.allSum }}</span>
      <span
        >{{ itemDetail.payAmountMoney.symbol }}
        {{ $currencyFormatter(itemDetail.payAmountMoney.number) }}</span
      >
    </div>
    <div class="button-box">
      <!-- 订单状态orderStatus： 1代付款 2待发货 3部分发货 4待收货 5交易成功 6已评价 7已取消 8交易关闭 -->
      <!-- <button v-if="itemDetail.orderStatus !== 1" @click="jumpDetail(itemDetail.id)">{{orderLan.lookDetail}}</button> -->
      
      <!-- <button
        v-if="itemDetail.orderStatus === 5"
        @click.stop="contactSeller(itemDetail.id)"
      >
        {{ orderLan.contactSeller }}
      </button> -->
      <button
        v-if="itemDetail.orderStatus === 4"
        @click.stop="confirm(itemDetail.id)"
      >
        {{ orderLan.confirmShop }}
      </button>
      <button
        v-if="itemDetail.orderStatus === 1"
        @click.stop="cancelPay(itemDetail.id)"
      >
        {{ orderLan.cancelOrder }}
      </button>
      <button
        v-if="itemDetail.orderStatus === 1"
        @click.stop="toPay(itemDetail)"
      >
        {{ orderLan.nowPay }}
      </button>
      <!-- <button v-if="itemDetail.orderStatus === 7 || itemDetail.orderStatus === 8" @click="deleteOrder(itemDetail.id)">{{orderLan.delOrder}}</button> -->
    </div>
  </div>
</template>

<script>
import GoodsInfo from "./goodsInfo";
import { Dialog } from "vant";
export default {
  components: {
    GoodsInfo,
  },
  props: {
    itemDetail: Object,
  },
  data() {
    return {
      orderLan: this.$t("message.order"),
    };
  },
  methods: {
    copyOrderNo(orderNo) {
      let textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = orderNo;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        this.$toast(this.$t("message.order.copySuccess"));
      } catch (err) {
        this.$toast(this.$t("message.room.copyError"));
      }

      document.body.removeChild(textArea);
    },
    jumpDetail(orderId) {
      this.$router.push({ path: "/order_detail", query: { orderId } });
    },
    cancelPay(id) {
      let that = this;
      Dialog.confirm({
        title: this.orderLan.cancelOrderAlert,
      })
        .then(() => {
          // on confirm
          that.$emit("cancelOrder", id);
        })
        .catch(() => {
          // on cancel
        });
    },
    toPay(orderNo) {
      this.$emit("toPay", orderNo);
    },
    deleteOrder(id) {
      this.$emit("deleteOrder", id);
    },
    contactSeller(){
      this.$emit("contactSeller");
    },
    confirm(id) {
      let that = this;
      Dialog.confirm({
        title: this.orderLan.confirmDeliveryAlert,
      })
        .then(() => {
          // on confirm
          that.$emit("confirmDelivery", id);
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style scoped lang="less">
.business {
  line-height: 0;
  display: flex;
  align-items: center;
  & span {
    height: 15px;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #161a1a;
    line-height: 15px;
    margin-bottom: 7.5px;
  }
  & img {
    width: 30px;
    height: 30px;
    margin-right: 6px;
    margin-bottom: 7px;
    border-radius: 36px;
  }
}
button {
  display: inline-block;
}
.order-item .order-item-top .left button {
  color: #333333 !important;
  border: 0.5px solid #333333;
}
.order-item {
    margin: 0 12px 10px 12px;
  width: auto;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  .order-item-top {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      p {
        margin-right: 4px;
        font-size: 13px;
        color: #5a5a5a;
      }
      button {
        padding: 2px 4px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.5px solid #333333;
        border-radius: 3px;
        background: #fff;
      }
    }
    .right {
      font-size: 13px;
      color: #eb2121;
    }
  }

  .order-info {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    :first-child {
      margin-right: 10px;
      font-size: 12px;
      color: #161a1a;
    }
    .total-text {
      font-size: 12px;
      color: #161a1a;
      margin-right: 5px;
    }
    :last-child {
      margin-left: 3px;
      font-size: 16px;
      color: #b4282d;
    }
  }
  .button-box {
    margin-bottom: 5px;
    display: flex;
    justify-content: flex-end;
    font-family: "TradeGothicLT";
    a,
    button {
      display: inline-block;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      background: #ffffff;
      border: 0.5px solid #161a1a;
      border-radius: 15px;
      font-size: 13px;
      color: #363636;
      margin-left: 10px;
      padding: 0 12.5px;
    }
  }
}
</style>
